import request from '@/util/request';

export default {
  overviewInfo: (data) => {
    return request({
        method: 'POST',
        url: '/overview/info',
        data
      }
    )
  }
}
